import { useEffect, useState } from 'react';
import Head from 'next/head';
import styles from '../styles/Home.module.css';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { loginRequest } from '../helpers/auth-config';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Grid, Paper, Button, Link, Tooltip } from '@mui/material';
import Image from 'next/image';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  GridContainer,
  GridItem,
  PaddedCard,
} from '../components/shared/ui-extension';

export default function Home() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [bottleNeck, setBottleNeck] = useState({ open: false });

  useEffect(() => {
    if (!isAuthenticated) {
      //instance.loginRedirect(loginRequest);
    }
    //login();

    /*if (isAuthenticated) {
      var request = {
        scopes: [],
      };

      instance
        .acquireTokenSilent(request)
        .then((tokenResponse) => {
          console.log(tokenResponse);
          // Do something with the tokenResponse
        })
        .catch((error) => {
          if (error /*instanceof InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return instance.acquireTokenRedirect(request);
          }
        });
    }*/
  }, [isAuthenticated]);

  useEffect(() => {
    setBottleNeck({
      open: true,
    });

    setTimeout(() => {
      setBottleNeck({
        open: false,
      });
    }, 3000);
  }, []);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  const handleLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <div className={styles.container}>
      <Head>
        <title>PAM</title>
        <link rel='icon' href='/favicon.ico' />
      </Head>

      <AuthenticatedTemplate>
        <GridContainer spacing={0} style={{ height: '100vh' }}>
          <GridItem xs={12} sm={12} md={12}>
            <Paper
              elevation={0}
              style={{
                display: 'flex',
                width: '100%',
                height: '100vh',
                flexDirection: 'row',
                justifyContent: 'space-between',
                textAlign: 'center',
                position: 'relative',
                top: '0',
                left: '0',
                right: '0',
                margin: '0 auto',
                padding: '20px',
                boxSizing: 'border-box',
                borderRadius: '10px',
              }}
            >
              <PaddedCard
                elevation={0}
                sx={{
                  width: '90%',
                  maxWidth: '600px',
                  height: '150px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mr: 2,

                  background: `linear-gradient(to top right, rgb(246, 246, 246), rgba(255, 255, 255, 1), rgb(237, 241, 248))`,
                  borderRadius: '10px',
                  border: 'none',
                }}
              >
                <Tooltip
                  title='Get The Latest Company News and Updates'
                  placement='top'
                  open={bottleNeck.open}
                  onOpen={() => setBottleNeck({ open: true })}
                  onClose={() => setBottleNeck({ open: false })}
                  arrow
                >
                  <Link
                    href={`${process.env.NEXT_PUBLIC_BOTTLENECK_URL}`}
                    target='_blank'
                  >
                    <Paper
                      elevation={0}
                      sx={{
                        width: '100%',
                        maxWidth: '250px',
                        padding: 2,
                        backgroundColor: 'transparent',
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                    >
                      <Image
                        className='u-center-image u-margin-bottom-small'
                        src='/bottleNeck-icon.png'
                        alt='bottle Neck icon'
                        height={105}
                        width={230}
                        sx={{
                          borderRadius: '5px',
                          mr: 1,
                          mb: 1.5,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          transition: 'transform 0.2s',
                        }}
                      />
                    </Paper>
                  </Link>
                </Tooltip>
              </PaddedCard>
              <PaddedCard
                elevation={0}
                sx={{
                  width: '90%',
                  height: '150px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mr: 2,
                  maxWidth: '600px',
                  background: `linear-gradient(to top right, rgb(246, 246, 246), rgba(255, 255, 255, 1), rgb(237, 241, 248))`,
                  borderRadius: '10px',
                  border: 'none',
                }}
              >
                <Tooltip
                  title='Access Your Paylocity Account'
                  placement='top'
                  arrow
                >
                  <Link href={'https://access.paylocity.com/'} target='_blank'>
                    <Image
                      className='u-center-image u-margin-bottom-small'
                      src='/clearRoundedPaylocity.png'
                      alt='Paylocity icon'
                      height={120}
                      width={235}
                      sx={{
                        borderRadius: '5px',
                        mr: 1,
                        mb: 1.5,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        background: `linear-gradient(to top right, rgb(246, 246, 246), rgba(255, 255, 255, 1), rgb(237, 241, 248))`,
                        cursor: 'pointer',
                        '&:hover': {
                          transform: 'scale(1.05)',
                        },
                        transition: 'transform 0.2s',
                      }}
                    />
                  </Link>
                </Tooltip>
              </PaddedCard>
              <PaddedCard
                elevation={0}
                sx={{
                  width: '90%',
                  height: '150px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  maxWidth: '600px',
                  padding: 2,
                  background: `linear-gradient(to top right, rgb(246, 246, 246), rgba(255, 255, 255, 1), rgb(237, 241, 248))`,
                  borderRadius: '10px',
                  border: 'none',
                }}
              >
                <Button
                  size='medium'
                  sx={{
                    height: '50px',
                    margin: '20px',
                    fontWeight: 'bold',
                    borderColor: '#1976d2',
                    borderWidth: '2px',
                    '&:hover': {
                      backgroundColor: 'rgb(255, 58, 58)',
                      color: '#fff',
                      borderColor: 'rgb(255, 58, 58)',
                      borderWidth: '2px',
                    },
                  }}
                  variant='contained'
                  onClick={() => handleLogout()}
                  endIcon={<LogoutIcon />}
                >
                  Log Out
                </Button>
              </PaddedCard>
            </Paper>
          </GridItem>
        </GridContainer>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button onClick={handleLogin}>Login</Button>
      </UnauthenticatedTemplate>
    </div>
  );
}
